import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";
import { SshUser } from "../sshuserinterface";

export const fetchSSHUsers = async (tenantName: string, deviceId: string): Promise<SshUser[]> => {
    const url = `${NGROK}/api/adcomputer/users/${tenantName}/computer-user?computerId=${deviceId}`;
    const data = await apiClient({
        method: "GET",
        url,
    });

    return data || [];
};


export const publishSSHUsers = async (tenantName: string, userId: string, roleList: string[], computerId: string) => {

    const url = `${NGROK}/api/adcomputer/users/${tenantName}/manage-computer-user?userId=${userId}&computerId=${computerId}&rolesList=${roleList}`;
    const data = await apiClient({
        method: "PUT",
        url,
    });
    return data;
}